import { useMemo, type FC } from "react"

import type { EntityType } from "types/common.types"
import type { AlertSettingType } from "types/alerts.types"
import AddPowerlineAlertSetting from "./powerline/AddPowerlineAlertSetting"
import AddDeviceAlertSetting from "./device/AddDeviceAlertSetting"
import AddTowerAlertSetting from "./tower/AddTowerAlertSetting"

interface AddAlertSettingsProps {
  types: AlertSettingType[]
  onClose: () => void
  entity: EntityType
  entityId: number
}

const AddAlertSetting: FC<AddAlertSettingsProps> = ({
  types,
  onClose,
  entity,
  entityId,
}) => {
  const content = useMemo(() => {
    switch (entity) {
      case "powerline":
        return (
          <AddPowerlineAlertSetting
            onClose={onClose}
            types={types}
            powerlineId={entityId}
          />
        )
      case "tower":
        return <AddTowerAlertSetting onClose={onClose} types={types} towerId={entityId} />
      case "device":
      default:
        return (
          <AddDeviceAlertSetting onClose={onClose} types={types} deviceId={entityId} />
        )
    }
  }, [entity, entityId, onClose, types])

  return content
}

export default AddAlertSetting
